import React from 'react';

const Paybill = () => {
  return (
    <div>
      <h1>Hello, React!</h1>
    </div>
  );
};

export default Paybill;
